import React from 'react';
import { Input, Modal, List, message, Button } from 'antd';
import SwitchShop from '../shop/switch-shop';
import getCurrentShop from '../shop/get-current-shop';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const [levels, setLevels] = React.useState([]);
    const [curruntShop, setCurruntShop] = React.useState(null);
    const [currentShopId, setCurrentShopId] = React.useState(null);

    React.useEffect(() => {
        const fetchShop = async () => {
            const shop = await getCurrentShop();
            setCurruntShop(shop);
            setCurrentShopId(shop ? shop.shopId : null);
        };
        
        fetchShop();
    }, []);
    
    React.useEffect(() => {
        if (currentShopId) {
            getLevels();
        }
    }, [currentShopId]);

    // 获取等级列表
    const getLevels = async () => {
        const response = await fetch('/api/shop/level-partner/list');
        
        const result = await response.json();

        if(result && result.success) {
            setLevels(result.data);
        }
    }

    const editLevel = async (levelId) => {
        Modal.confirm({
            icon: null,
            title: '编辑代理等级',
            content: <div>
                <Input defaultValue={levels.find((item) => item.id === levelId)?.title} id="level-title" />
            </div>,
            onOk: () => {
                const levelTitle = document.getElementById('level-title').value;
                if(levelTitle) requestEditLevel(levelId, levelTitle);
            }
        })
    }

    const requestEditLevel = async (levelId, levelTitle) => {
        const url = levelId ? `/api/shop/level-partner/edit` : `/api/shop/level-partner/create`;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                levelId,
                levelTitle
            })
        });
        const result = await response.json();

        if(result && result.success) {
            
            message.success({
                content: '编辑成功'
            });

            getLevels();
        }
    }
// /api/shop/level-partner/delete
    const addLevel = () => {
        Modal.confirm({
            icon: null,
            title: '添加等级',
            content: <div>
                <Input id="level-title" />
            </div>,
            onOk: () => {
                const levelTitle = document.getElementById('level-title').value;
                if(levelTitle) requestEditLevel(null, levelTitle);
                else message.error('请填写等级名称');
            }
        })
    }

    const delLevel = (levelId) => { 
        Modal.confirm({
            icon: null,
            title: '确定删除？',
            onOk: () => {
                requestDelLevel(levelId);
            }
        })
    }

    const requestDelLevel = async (levelId) => { 
        const response = await fetch('/api/shop/level-partner/delete', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                levelId,
            })
        });
        const result = await response.json();

        if(result && result.success) {
            
            message.success({
                content: '删除成功'
            });

            getLevels();
        }else{
            message.error({
                content: '删除失败'
            });
        }
    }

    return (
        <div>
            <SwitchShop />
            <h2>代理等级</h2>
            <List bordered>
                {
                    levels && levels.map((item, index) => {
                        return <List.Item key={item.id}
                            actions={[
                                <a href={`/salesnet?tab=proxy&levelId=${item.id}&shopId=${currentShopId}`}>查看代理商</a>,
                                <a onClick={() => editLevel(item.id)}>编辑</a>,
                                <a onClick={() => delLevel(item.id)}>删除</a>
                            ]}
                        >
                            <div>{item.title}</div>
                            <div>{item.remark}</div>
                        </List.Item>
                    })
                }
            </List>
            <Button style={{margin: '10px 0 0 0'}} type="primary" onClick={() => addLevel()}>添加等级</Button>
        </div>
    )
}